function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React, { useContext, useEffect } from 'react';
import classnames from 'classnames';
import { Icon } from "../../Icon/Icon/Icon";
import Utility from "../../Utility/Utility";
import { ThemeContext } from "../../../context/theme.context";
import styles from "./BackgroundVideo.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var backgroundVideoAlign = ['top', 'center', 'bottom'];
export var backgroundVideoDefaultProps = {
  height: 500,
  verticalAlign: 'center',
  scaleVideo: true,
  scrimOpacity: 0,
  alt: '',
  playTitle: 'Play video',
  pauseTitle: 'Pause video'
};
export var BackgroundVideo = function BackgroundVideo(_ref) {
  var originalSources = _ref.sources,
    _ref$poster = _ref.poster,
    poster = _ref$poster === void 0 ? '' : _ref$poster,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? backgroundVideoDefaultProps.height : _ref$height,
    _ref$verticalAlign = _ref.verticalAlign,
    verticalAlign = _ref$verticalAlign === void 0 ? backgroundVideoDefaultProps.verticalAlign : _ref$verticalAlign,
    _ref$scaleVideo = _ref.scaleVideo,
    scaleVideo = _ref$scaleVideo === void 0 ? backgroundVideoDefaultProps.scaleVideo : _ref$scaleVideo,
    _ref$scrimOpacity = _ref.scrimOpacity,
    scrimOpacity = _ref$scrimOpacity === void 0 ? backgroundVideoDefaultProps.scrimOpacity : _ref$scrimOpacity,
    videoAttributes = _ref.videoAttributes,
    onPlay = _ref.onPlay,
    onPause = _ref.onPause,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? backgroundVideoDefaultProps.alt : _ref$alt,
    _ref$playTitle = _ref.playTitle,
    playTitle = _ref$playTitle === void 0 ? backgroundVideoDefaultProps.playTitle : _ref$playTitle,
    _ref$pauseTitle = _ref.pauseTitle,
    pauseTitle = _ref$pauseTitle === void 0 ? backgroundVideoDefaultProps.pauseTitle : _ref$pauseTitle,
    buttonLocation = _ref.buttonLocation,
    buttonColorProp = _ref.buttonColor;
  var theme = useContext(ThemeContext);
  var vidRef = /*#__PURE__*/React.createRef();
  var playButtonRef = /*#__PURE__*/React.createRef();
  var pauseButtonRef = /*#__PURE__*/React.createRef();
  var isPlaying = videoAttributes && videoAttributes.autoPlay === false ? false : true;
  var updatePlayPause = function updatePlayPause() {
    if (!playButtonRef || !playButtonRef.current || !pauseButtonRef || !pauseButtonRef.current) {
      return;
    }
    if (isPlaying) {
      playButtonRef.current.classList.remove('show');
      pauseButtonRef.current.classList.add('show');
    } else {
      playButtonRef.current.classList.add('show');
      pauseButtonRef.current.classList.remove('show');
    }
  };

  // Show pause button on mount if autoPlay is true.
  // Should not update if autoPlay prop is changed.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(function () {
    return updatePlayPause();
  }, []);
  var playVideo = function playVideo() {
    isPlaying = true;
    if (vidRef && vidRef.current) {
      vidRef.current.play();
      if (onPlay) {
        onPlay();
      }
    }
    updatePlayPause();
  };
  var pauseVideo = function pauseVideo() {
    isPlaying = false;
    if (vidRef && vidRef.current) {
      vidRef.current.pause();
      if (onPause) {
        onPause();
      }
    }
    updatePlayPause();
  };
  var containerStyles = {
    height: height ? "".concat(height, "px") : undefined
  };
  var sources = scaleVideo && originalSources ? originalSources.map(function (source) {
    return Object.assign({}, source, {
      src: Utility.getOptimizedCloudinaryUrl(source.src, {
        height: height
      })
    });
  }) : originalSources;
  var mainSource = sources && sources[0] && sources[0].src ? sources[0].src : null;

  // Force video to update if source updates (eg. storybook).
  var videoKey = mainSource ? mainSource : 'no-video';
  var defaultVideoAttributes = {
    autoPlay: true,
    controls: false,
    loop: true,
    muted: true,
    playsInline: true
  };

  // HTML5 video tag attributes.
  var attributes = Object.assign({}, _objectSpread(_objectSpread({}, defaultVideoAttributes), {}, {
    poster: poster
  }), videoAttributes);
  var defaultButtonLocation = {
    bottom: '50px',
    right: '50px'
  };
  var buttonWrapperStyle = Object.assign({}, defaultButtonLocation, buttonLocation);
  var buttonColor = buttonColorProp ? buttonColorProp : theme === 'lightBackground' ? 'black' : 'white';
  return /*#__PURE__*/_jsxs("div", {
    className: styles.container,
    style: containerStyles,
    children: [/*#__PURE__*/_jsx("video", _objectSpread(_objectSpread({
      ref: vidRef,
      className: classnames({
        [styles.video]: true,
        [styles.alignTop]: verticalAlign === 'top',
        [styles.alignBottom]: verticalAlign === 'bottom'
      })
    }, attributes), {}, {
      children: sources && sources.map(function (source, key) {
        return /*#__PURE__*/_jsx("source", {
          src: source.src,
          type: source.type
        }, key);
      })
    }), videoKey), !!scrimOpacity && /*#__PURE__*/_jsx("div", {
      className: classnames({
        [styles.scrim]: true,
        [styles.dark]: theme === 'darkBackground',
        [styles.light]: theme === 'lightBackground'
      }),
      style: {
        opacity: scrimOpacity
      }
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.buttonWrapper,
      style: buttonWrapperStyle,
      children: [/*#__PURE__*/_jsx("button", {
        ref: playButtonRef,
        className: classnames(styles.button, styles[buttonColor]),
        onClick: playVideo,
        title: playTitle,
        children: /*#__PURE__*/_jsx(Icon, {
          width: "25px",
          type: "play-background-video"
        })
      }), /*#__PURE__*/_jsx("button", {
        ref: pauseButtonRef,
        className: classnames(styles.button, styles[buttonColor]),
        onClick: pauseVideo,
        title: pauseTitle,
        children: /*#__PURE__*/_jsx(Icon, {
          width: "25px",
          type: "pause-background-video"
        })
      })]
    }), alt && /*#__PURE__*/_jsx("div", {
      className: styles.screenReader,
      children: alt
    })]
  });
};